import React, { useState, useEffect } from "react";

export const StyleContext = React.createContext({});

export const StyleLoadingContext = React.createContext(true);

/**
 * Hook that returns the styles object (backward compatible).
 * All ~48 consumer components continue to work unchanged.
 */
export const useStyleContext = () => {
    return React.useContext(StyleContext);
}

/**
 * Hook to check if styles are still loading.
 */
export const useStyleLoading = () => {
    return React.useContext(StyleLoadingContext);
}

/**
 * StyleProvider fetches website content from /api/website-content
 * and provides it via StyleContext.
 */
export const StyleProvider = ({ children }) => {
    const [styles, setStyles] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetch('/api/website-content')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch website content');
                }
                return response.json();
            })
            .then(data => {
                setStyles(data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error fetching website content:', error);
                setIsLoading(false);
            });
    }, []);

    return (
        <StyleLoadingContext.Provider value={isLoading}>
            <StyleContext.Provider value={styles}>
                {children}
            </StyleContext.Provider>
        </StyleLoadingContext.Provider>
    );
}

/**
 * @deprecated Use StyleProvider + useStyleContext instead.
 * Kept for backward compatibility during transition.
 */
export const styleContextRawData = () => {
    if (typeof page_data !== 'undefined') {
        return page_data;
    } else if (typeof websiteStyles !== 'undefined') {
        return websiteStyles;
    } else {
        return {};
    }
}
